import dayjs from "dayjs";
import React, { useEffect, useRef, useState } from "react";

import { createJobValidations } from "@/utilities/CommonText";
import {
  isKeyUpValid,
  showErrorToast,
  validateTimeFormat,
} from "@/utilities/utils";

const CustomField = ({ isCustom, curTime, handleBlur, labelClicked }) => {
  const [value, setValue] = useState("");
  useEffect(() => {
    if (isCustom) {
      setValue(curTime);
    } else {
      setValue("Custom");
    }
  }, []);
  const firstRender = useRef(true);
  useEffect(() => {
    if (firstRender.current) {
      firstRender.current = false;
      return;
    }
    setValue("Custom");
  }, [labelClicked]);
  return (
    <input
      className={`pointer-events-auto relative flex h-[35px] w-[95px] cursor-pointer items-center justify-center rounded-lg text-sm font-medium leading-[35px] ${
        isCustom
          ? "border-primary bg-primary text-white"
          : "border-lightblue bg-lightblue text-primary"
      } focus:boder-primary border text-center transition-[border] focus:bg-lightblue focus:text-primary`}
      onKeyDownCapture={(e) => {
        let curVal = e.target.value;
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
        }
        let isNumber = /^\d+$/.test(e.key);
        if (isKeyUpValid(e.key)) {
          e.preventDefault();
        }
        if (curVal.length === 5 && isNumber) {
          e.preventDefault();
        }
      }}
      onChange={(e) => {
        // let curVal = e.target.value;
        // if (curVal.length === 2) {
        //   e.target.value = curVal + ":";
        // }
        setValue(e.target.value);
      }}
      onKeyUp={(e) => {
        let curVal = value;
        if (curVal.length) {
          if (e.key === "Backspace") {
            if (curVal.length === 2) {
              setValue(curVal.slice(0, 1));
            }
          } else {
            if (curVal.length === 2) {
              setValue(curVal + ":");
            }
          }
          return;
        }
      }}
      onPasteCapture={(e) => {
        e.preventDefault();
      }}
      onFocus={(e) => {
        if (isCustom) {
          setValue(curTime);
        } else {
          setValue("");
        }
      }}
      onBlur={(e) => {
        if (dayjs(value, "HH", true).isValid()) {
          let curMin = dayjs().minute();
          setValue(value + ":" + curMin);
        }
        if (dayjs(value, "HH:", true).isValid()) {
          let curMin = dayjs().minute();
          // e.target.innerText = e.target.innerText + curMin;
          setValue(value + curMin);
        }
        if (validateTimeFormat(value)) {
          handleBlur(value);
        } else {
          if (value === "") {
            // showErrorToast(createJobValidations.emptyFields);
          } else {
            // showErrorToast(createJobValidations.inValidTimeFormat);
            showErrorToast(createJobValidations.enterValidTimeFormat);
          }
          if (isCustom && value !== "") {
            setValue(curTime);
          } else {
            handleBlur("00:00", false);
            setValue("Custom");
          }
        }
      }}
      suppressContentEditableWarning={true}
      value={value}
      placeholder="hh:mm"
    />
  );
};

export default CustomField;
